import React from 'react';
import SocialIterationsComponent from '../components/SocialIterationsV2';
import { AddonsContextConsumer } from '../../Addons/context/AddonsContext';

function SocialIteration(props) {
  return (
    <AddonsContextConsumer>
      {({ actions: { getCurrencySymbol, getCurrencyIcon } }) =>
      <SocialIterationsComponent
        {...props}
        getCurrencySymbol={getCurrencySymbol}
        getCurrencyIcon={getCurrencyIcon} />}


    </AddonsContextConsumer>);

}

export default SocialIteration;